import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateFormat',
  standalone: true,
})
export class DateFormatPipe implements PipeTransform {
  transform(value: any, format: 'date' | 'datetime' | 'time' = 'date'): string {
    if (!value) return '';

    // Forzar formato UTC si viene como "yyyy-MM-dd HH:mm:ss"
    if (typeof value === 'string' && !value.includes('T')) {
      value = value.replace(' ', 'T') + 'Z';
    }

    const date = new Date(value);
    if (isNaN(date.getTime())) return '';

    // Opciones de formato de acuerdo al tipo
    let options: Intl.DateTimeFormatOptions = { timeZone: 'America/Santiago' };

    if (format === 'date') {
      options = {
        ...options,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      };
    } else if (format === 'time') {
      options = {
        ...options,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      };
    } else if (format === 'datetime') {
      options = {
        ...options,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      };
    }

    return new Intl.DateTimeFormat('es-CL', options).format(date);
  }
}
